import { render } from "./App.vue?vue&type=template&id=009072bd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=009072bd&lang=css"

import exportComponent from "/home/runner/work/aniketkabra.github.io/aniketkabra.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__